
import PropTypes from 'prop-types'
import React from 'react'
import className from 'classnames'
import './Switch.css'

const Switch = props => {
  const { checked, onChange, disabled, large } = props

  const classes = className({
    'ui-Switch': true,
    'ui-Switch-checked': checked,
    'ui-Switch-disabled': disabled,
    'ui-Switch-large': large
  })

  return (
    <div className={classes} onClick={toggle}>
      <div className='ui-Switch-labels'>
        <div className='ui-Switch-label' />
        <div className='ui-Switch-label' />
      </div>
      <div className='ui-Switch-handle' />
    </div>
  )

  function toggle (e) {
    if (!disabled) onChange(!checked)
    e.stopPropagation()
  }
}

Switch.displayName = 'Switch'

Switch.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  large: PropTypes.bool,
  onChange: PropTypes.func.isRequired
}

export default Switch



// WEBPACK FOOTER //
// ./ui/Switch.js